/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import IFilas from 'Infotrack@Modelos/smartStock/filas/entidades/filas';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorIndicadorCargaGlobal,
    manejadorDialogoGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FilasCM from '../controladorModelo/filasCM';
import { acciones, IEstadoFilas } from '../reductorFilas';
import FilasVista from '../vista/tablaFilasVista';
import Texto from '@infotrack/presentacion-componentes/texto';
import { useSelector } from 'react-redux';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';

const filasCM = new FilasCM();

const TableFilasCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [filass, setFilass] = React.useState<IFilas[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoFilas>();
    const idEmpresa = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdEmpresa);
    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarFilas();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarFilas = () => {
        manejadorIndicadorCargaGlobal(true);
        filasCM.consultarFilasPorFiltro({EmpresaId:idEmpresa}).then((filass) => {
            setFilass(modificarPropiedadesFilas(filass));
            manejadorIndicadorCargaGlobal(false);
        });
    };

    const modificarPropiedadesFilas = (filas: IFilas[]) => {
        return filas.map((fila) => ({
            ...fila,
            Estado: fila.Estado !== 1 ? 0 : fila.Estado,
        }));
    };

    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadFilas?: IFilas) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadFilas, tipoFormulario } });
    };

    const confirmarEliminacion = (filas: IFilas) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarFilas(filas),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const eliminarFilas = (filas: IFilas) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        filasCM.eliminarFilas(filas).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <FilasVista
            filass={filass}
            cargarFilas={cargarFilas}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableFilasCV;
